import { SubCategoryModel } from '../SubCategoryModel';

export class SubCategoryList {
  static subCategoryItem: Array<SubCategoryModel> = [] as Array<SubCategoryModel>;

  static get subCategoryItems() {
    return (this.subCategoryItem = [
      { id: 7, name: 'Most Scoring Topics in IIT JEE', SubCategory: 1 },
      { id: 37, name: 'IIT JEE Entrance Exam', SubCategory: 1 },
      { id: 2, name: 'Discuss with Colleagues and IITians', SubCategory: 1 },
      { id: 39, name: 'Engineering Entrance Exams', SubCategory: 1 },
      { id: 8, name: 'Branch Ranking of IIT', SubCategory: 1 },
      { id: 33, name: 'Discuss with Askiitians Tutors', SubCategory: 1 },
      { id: 55, name: 'NEET[AIPMT]', SubCategory: 1 },
      { id: 6, name: 'Marks and Rank in IIT JEE', SubCategory: 1 },
      { id: 54, name: 'AIIMS MBBS', SubCategory: 1 },
      { id: 5, name: 'Top Engineering Colleges in India', SubCategory: 1 },
      { id: 38, name: 'AIEEE Entrance Exam', SubCategory: 1 },
      { id: 32, name: 'General Knowledge', SubCategory: 1 },

      { id: 7, name: 'Most Scoring Topics in IIT JEE', SubCategory: 6 },
      { id: 37, name: 'IIT JEE Entrance Exam', SubCategory: 6 },
      { id: 2, name: 'Discuss with Colleagues and IITians', SubCategory: 6 },
      { id: 39, name: 'Engineering Entrance Exams', SubCategory: 6 },
      { id: 8, name: 'Branch Ranking of IIT', SubCategory: 6 },
      { id: 33, name: 'Discuss with Askiitians Tutors', SubCategory: 6 },
      { id: 55, name: 'NEET[AIPMT]', SubCategory: 6 },
      { id: 6, name: 'Marks and Rank in IIT JEE', SubCategory: 6 },
      { id: 54, name: 'AIIMS MBBS', SubCategory: 6 },
      { id: 5, name: 'Top Engineering Colleges in India', SubCategory: 6 },
      { id: 38, name: 'AIEEE Entrance Exam', SubCategory: 6 },
      { id: 32, name: 'General Knowledge', SubCategory: 6 },

      { id: 10, name: 'Mechanics', SubCategory: 2 },
      { id: 14, name: 'Electric Current', SubCategory: 2 },
      { id: 11, name: 'Wave Motion', SubCategory: 2 },
      { id: 15, name: 'Magnetism', SubCategory: 2 },
      { id: 18, name: 'Modern Physics', SubCategory: 2 },
      { id: 12, name: 'Thermal Physics', SubCategory: 2 },
      { id: 16, name: 'Electromagnetic Induction', SubCategory: 2 },
      { id: 9, name: 'General Physics', SubCategory: 2 },
      { id: 13, name: 'Electrostatics', SubCategory: 2 },
      { id: 17, name: 'Wave Optics', SubCategory: 2 },
      { id: 60, name: 'Physics Others', SubCategory: 2 },


      { id: 10, name: 'Mechanics', SubCategory: 7 },
      { id: 14, name: 'Electric Current', SubCategory: 7 },
      { id: 11, name: 'Wave Motion', SubCategory: 7 },
      { id: 15, name: 'Magnetism', SubCategory: 7 },
      { id: 18, name: 'Modern Physics', SubCategory: 7 },
      { id: 12, name: 'Thermal Physics', SubCategory: 7 },
      { id: 16, name: 'Electromagnetic Induction', SubCategory: 7 },
      { id: 9, name: 'General Physics', SubCategory: 7 },
      { id: 13, name: 'Electrostatics', SubCategory: 7 },
      { id: 17, name: 'Wave Optics', SubCategory: 7 },
      { id: 64, name: 'Physics Others', SubCategory: 7 },

      { id: 19, name: 'Physical Chemistry', SubCategory: 3 },
      { id: 21, name: 'Organic Chemistry', SubCategory: 3 },
      { id: 20, name: 'Inorganic Chemistry', SubCategory: 3 },
      { id: 61, name: 'Chemistry Others', SubCategory: 3 },

      { id: 19, name: 'Physical Chemistry', SubCategory: 8 },
      { id: 21, name: 'Organic Chemistry', SubCategory: 8 },
      { id: 20, name: 'Inorganic Chemistry', SubCategory: 8 },
      { id: 65, name: 'Chemistry Others', SubCategory: 8 },

      { id: 22, name: 'Algebra', SubCategory: 4 },
      { id: 23, name: 'Trigonometry', SubCategory: 4 },
      { id: 24, name: 'Analytical Geometry', SubCategory: 4 },
      { id: 25, name: 'Differential Calculus', SubCategory: 4 },
      { id: 26, name: 'Integral Calculus', SubCategory: 4 },
      { id: 27, name: 'Vectors', SubCategory: 4 },
      { id: 29, name: 'Magical Mathematics[Interesting Approach]', SubCategory: 4 },
      { id: 62, name: 'Maths Others', SubCategory: 4 },

      { id: 22, name: 'Algebra', SubCategory: 9 },
      { id: 23, name: 'Trigonometry', SubCategory: 9 },
      { id: 24, name: 'Analytical Geometry', SubCategory: 9 },
      { id: 25, name: 'Differential Calculus', SubCategory: 9 },
      { id: 26, name: 'Integral Calculus', SubCategory: 9 },
      { id: 27, name: 'Vectors', SubCategory: 9 },
      { id: 29, name: 'Magical Mathematics[Interesting Approach]', SubCategory: 9 },
      { id: 66, name: 'Maths Others', SubCategory: 9 },

      { id: 52, name: 'Botany', SubCategory: 5 },
      { id: 53, name: 'Zoology', SubCategory: 5 },
      { id: 63, name: 'Biology Others', SubCategory: 5 },

      { id: 52, name: 'Botany', SubCategory: 10 },
      { id: 53, name: 'Zoology', SubCategory: 10 },
      { id: 67, name: 'Biology Others', SubCategory: 10 },
    ]);
  }
}
